/**
 * Long text fields that offer "Sugerir com IA". Each one's guidance for the model (the mini prompt)
 * lives in the translations, under components.aiTextArea.instructions.<field>, so it follows the
 * panel language; the limit is enforced on the answer too.
 */
export const AI_FIELDS = {
  "welcome.featuredTitle": { maxLength: 80 },
  "welcome.supportingText": { maxLength: 160 },
  "about.featuredText": { maxLength: 120 },
  "about.completeDescription": { maxLength: 600 },
  "highlights.description": { maxLength: 200 },
  "catalog.description": { maxLength: 80 },
  "form.successMessage": { maxLength: 160 },
} satisfies Record<string, { maxLength?: number }>;

export type AiFieldKey = keyof typeof AI_FIELDS;
